import React from 'react';
import { FormattedTag } from 'core/components';
import { IconInfoSecondary } from 'components/icons/icon-info/icon-info-secondary';

import './domain-badge.scss';

export const DomainBadge = () => (
  <div className="domain-badge d-flex align-items-center justify-content-start p-1_5 mx-1_5 mb-2">
    <IconInfoSecondary className="domain-badge-icon-info mr-1" />
    <div className="domain-bar-messages d-flex flex-column align-items-start pl-0_5 pr-1_5">
      <FormattedTag id="domain.bar.message1" className="font-weight-normal m-0" />
      <FormattedTag id="domain.bar.link" className="domain-badge-link text-white m-0" />
    </div>
  </div>
);
